import { render, staticRenderFns } from "./RelatedUsersAppraisal.vue?vue&type=template&id=24b2ec5c&"
import script from "./RelatedUsersAppraisal.vue?vue&type=script&lang=js&"
export * from "./RelatedUsersAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports